import { Request } from '../request';

const getOne = (id: string): Request => ({
	method: 'get',
	url: `api/tech-partners/${id}/`
});

export default getOne;
